function toFiniteNumber(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/** Whole-shekel payable cap for LDS agent payment links (matches BE ceil SSOT). */
export function ceilLdsPaymentRemainingAmount(remaining) {
  const n = toFiniteNumber(remaining);
  if (n == null || n <= 0) return 0;
  return Math.ceil(n - 1e-9);
}

export function maxAllowedLdsPaymentAmount(remaining) {
  return ceilLdsPaymentRemainingAmount(remaining);
}

export function isLdsPaymentAmountWithinRoundingTolerance(amount, remaining) {
  const parsedAmount = toFiniteNumber(amount);
  const maxAllowed = maxAllowedLdsPaymentAmount(remaining);
  if (parsedAmount == null || parsedAmount <= 0) return false;
  return parsedAmount <= maxAllowed;
}

export function buildLdsPaymentRoundingTrace(remaining, requested) {
  const remainingAmount = toFiniteNumber(remaining);
  const roundedRequestedAmount = maxAllowedLdsPaymentAmount(remaining);
  const req = toFiniteNumber(requested);
  const roundingDelta =
    remainingAmount != null && roundedRequestedAmount != null
      ? Number((roundedRequestedAmount - remainingAmount).toFixed(2))
      : null;
  const allowed = isLdsPaymentAmountWithinRoundingTolerance(requested, remaining);
  const allowedByRoundingTolerance =
    allowed &&
    remainingAmount != null &&
    req != null &&
    req > remainingAmount + 0.02;
  return {
    remainingAmount,
    roundedRequestedAmount,
    roundingDelta,
    allowedByRoundingTolerance,
    requested_amount: req,
    allowed,
  };
}
